import api from '@/api/Api'

export const state = {
  currentIndustry: null,
  industries: []
}

export const getters = {
  currentIndustry (state) {
    return state.currentIndustry
  },
  industries (state) {
    return state.industries
  }
}

export const mutations = {
  SET_CURRENT_INDUSTRY (state, newValue) {
    state.currentIndustry = newValue
  },
  SET_INDUSTRIES (state, newValue) {
    state.industries = newValue
  }
}
export const actions = {
  async setIndustry ({ commit, state, rootState }, industry) {
    return await api.updateUser(industry)
  }
}



// WEBPACK FOOTER //
// ./src/state/modules/industry.js